import globalIP from '@/GlobelIP';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, Col, FlexboxGrid, Input, Modal, SelectPicker, Stack, Form } from 'rsuite';

export default function CopyCatalogue({
  open,
  close,
  allData,
  CheckCredentials,
  setCatalogueData2
}) {
  const [metaData, setMetaData] = useState<boolean | undefined>();
  const [isLoading, setIsLoading] = useState(false);
  const [companydataa, setCompanydataa] = useState([]);
  const [buyeerdata, setBuyeerdata] = React.useState([]);
  const [catalogueData, setCatalogueData] = useState({
    catalogueName: '',
    BuyerCompany: '',
    BuyerName: '',
    BuyerEmail: ''
  });
  const generateCatalogue = () => {
    const nextCode = +metaData + 1;
    return `CATLG-${nextCode.toString().padStart(3, '0')}`;
  };
  useEffect(() => {
    const fetchData = async () => {
      const {
        data: {
          meta: {
            pagination: { total }
          }
        }
      } = await axios.get(`${globalIP}/api/catalogues`);
      setMetaData(total);
    };
    const fetchData2 = async () => {
      try {
        const response = await fetch(`${globalIP}/api/buyer-companies`);
        const json = await response.json();
        const processedData = json.data.map(item => ({
          label: item.attributes.companynm,
          value: item.attributes.companynm
        }));
        setCompanydataa(processedData);
      } catch (error) {
        console.error('Error fetching category data:', error);
      }
    };
    const fetchData3 = async () => {
      try {
        const response = await fetch(
          `${globalIP}/api/buyer-details?populate=*&filters[dis][$ne]=Discontinue`
        );
        const json = await response.json();
        const processedData = json.data.map(item => ({
          label: item.attributes.buyernm,
          value: item.attributes.buyernm,
          company: item.attributes.companynm
        }));
        setBuyeerdata(processedData);
      } catch (error) {
        console.error('Error fetching category data:', error);
      }
    };
    fetchData();
    fetchData2();
    fetchData3();
  }, [allData]);

  const filteredBuyerData = catalogueData.BuyerCompany
    ? buyeerdata.filter(item => item.company == catalogueData.BuyerCompany)
    : [];

  const handleChange = (key, value) => {
    setCatalogueData(prev => {
      if (value === null) {
        return { ...prev, [key]: '' }; // Set to an empty string or handle as needed
      }
      const replacedValue = value.replace(/\s+/g, ' ');
      const trimmedValue = replacedValue.startsWith(' ') ? replacedValue.slice(1) : replacedValue;
      return { ...prev, [key]: trimmedValue };
    });
  };

  const handleSubmit = async () => {
    if (catalogueData.catalogueName != '' && catalogueData.catalogueName != ' ') {
      setIsLoading(true);
      const { catalogueName, BuyerCompany, BuyerName, BuyerEmail, CatalogueCode, ...restdata } =
        allData.attributes;
      const newData = {
        ...catalogueData,
        ...restdata,
        CatalogueCode: generateCatalogue(),
        LinkStatus: null,
        Glink: null,
        Status: 'Active'
      };
      const {
        data: { data }
      } = await axios.post(`${globalIP}/api/catalogues?populate=*`, { data: newData });
      const itemCount = data.attributes.CatalogueProduct.length;
      console.log('data');
      console.log(data);
      if (data) {
        CheckCredentials('Create SuccessFully', 'success');
        close();
        setCatalogueData2(prev => [{ ...data, itemCount }, ...prev]);
        setIsLoading(false);
      }
    } else {
      CheckCredentials('Catalogue Name is Required', 'error');
    }
  };

  return (
    <Modal open={open} onClose={close} backdrop={'static'} size="lg">
      <Modal.Header>
        <b>Please fill the catalogue details.</b>
      </Modal.Header>
      <Modal.Body>
        <Form fluid>
          <FlexboxGrid>
            <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>
                  <Stack>
                    <p>Catalogue Name </p>
                    <p style={{ color: 'red' }}>*</p>
                  </Stack>
                </Form.ControlLabel>
                <Input
                  id="catalogueName"
                  name="catalogueName"
                  value={catalogueData.catalogueName}
                  onChange={value => handleChange('catalogueName', value)}
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6} style={{ marginBottom: '20px' }}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>Buyer Company</Form.ControlLabel>
                <SelectPicker
                  data={companydataa.length ? companydataa : []}
                  labelKey="label"
                  valueKey="value"
                  id="BuyerCompany"
                  name="BuyerCompany"
                  value={catalogueData.BuyerCompany}
                  onChange={value => handleChange('BuyerCompany', value)}
                  style={{ width: '100%' }}
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                <SelectPicker
                  labelKey="label"
                  valueKey="value"
                  data={filteredBuyerData}
                  id="BuyerName"
                  name="BuyerName"
                  value={catalogueData.BuyerName}
                  onChange={value => handleChange('BuyerName', value)}
                  style={{ width: '100%' }}
                />
              </Form.Group>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={6}>
              <Form.Group controlId="email-1">
                <Form.ControlLabel>Buyer Email ID (optional)</Form.ControlLabel>
                <Input
                  id="BuyerEmail"
                  name="BuyerEmail"
                  value={catalogueData.BuyerEmail}
                  onChange={value => handleChange('BuyerEmail', value)}
                />
              </Form.Group>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Stack justifyContent="flex-end">
          <Button appearance="primary" color="cyan" onClick={handleSubmit} disabled={isLoading}>
            Finish
          </Button>
        </Stack>
      </Modal.Footer>
    </Modal>
  );
}
